import { Component } from '@angular/core';

@Component({
  selector: 'app-global-search-result-skeleton-loader',
  standalone: true,
  imports: [],
  templateUrl: './global-search-result-skeleton-loader.component.html',
  styleUrl: './global-search-result-skeleton-loader.component.scss'
})
export class GlobalSearchResultSkeletonLoaderComponent {

}
